import { FunctionComponent } from "react";
import { Step } from "@App/Components/Stepper/Step";
import { MessageStep } from "@App/Components/molecules/whitelabel/home/stepper/MessageStep";
import { useTranslation } from "react-i18next";
import { ChildStepProps } from "@App/Components/molecules/whitelabel/home/stepDefinitions/ChildStepProps";

type MessageStepDefinitionProps = {
  onSubmit: (message: string) => void;
} & ChildStepProps;

export const MessageStepDefinition: FunctionComponent<MessageStepDefinitionProps> = ({
  onSubmit,
  ...stepProps
}: MessageStepDefinitionProps) => {
  const { t } = useTranslation();
  return (
    <Step
      {...stepProps}
      title={t("home.steps.message.title")}
      completedTitle={t("home.steps.message.completedTitle")}
      completedGoBackLinkTitle={t("home.steps.message.backlink.title")}
    >
      <MessageStep onSubmit={onSubmit} />
    </Step>
  );
};
